import Select, { components } from "react-select";
import React, { useState, useEffect, useRef }  from 'react';
import {selectImg} from '../../utils/img';
export default function SelectMaterial(props){
        const options = props.options;
        const [menuIsOpen, setMenuOpen] = React.useState(false);
        const [tempValue, setTempValue] = React.useState('')
        const selectRef = React.useRef(null);
        const prevOptions = usePrevious(props.options);
        useEffect(() => {
            if((JSON.stringify(props.options) !== JSON.stringify(prevOptions)) && props.name === 'color') {
                onClear();
            }
        });

        const onClear = () => {
            selectRef.current.clearValue();
        };

        function usePrevious(value) {
            const ref = useRef();
            useEffect(() => {
                ref.current = value; //assign the value of ref to the argument
            },[value]); //this code will run when the value of 'value' changes
            return ref.current; //in the end, return the current ref value.
        }

        const DropdownIndicator = (
            props: ElementConfig<typeof components.DropdownIndicator>
          ) => {
            return (
              <components.DropdownIndicator {...props}>
                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L8 8.5L15 1.5" stroke="black" strokeWidth="2"/>
                </svg>
              </components.DropdownIndicator>
            );
          };

        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                padding:"0.5rem 0.625rem",
                backgroundColor: '#EDEDED',
                transition: '0.1s cubic-bezier(.7,.33,.25,.87)',
                cursor: 'pointer',
                fontFamily: `'EuropeCondensedc', 'Loos Light', sans-serif`,
                '&:hover': {
                    backgroundColor: '#00AD26',
                    color: 'white'
                },
                'div' : {
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center',
                    width: 'calc(100% - 2rem)'
                    
                },
                'span': {
                    width: '7rem'
                },
                'img': {
                    height: '2rem',
                    width: '50%',
                    objectFit: 'cover'
                }

                
            }),
            menu: (provided, state) => ({
                ...provided,
                backgroundColor: '#EDEDED',
                borderRadius: 0,
                transition: '0.3s cubic-bezier(.7,.33,.25,.87)',
                border: `${!props.validate && tempValue===''  ? '1px solid #EB5757' : '1px solid transparent'}`,
                borderTop: '1px solid transparent',
                marginTop: '1px',
                padding: '0',
                borderTop: '1px solid white',
                boxShadow: 'none',
                zIndex: '2'
                

            }),


            menuList: (provided, state) => ({
                ...provided,
                padding: '0',
            }),

            

            valueContainer: (provided, state, ...props) => (
                {
                ...provided,
                padding: '0',
                height: '3.4375rem',
                width: '14rem',
                'div' : {
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center',
                    width: '100%'
                },
                'span': {
                    width: 'max-content',
                    position: 'absolute',
                    padding: '0.125rem',
                    left: '0',
                    top: '0',
                    zIndex: '1',
                    color: 'black',
                    backgroundColor: '#EDEDED'
                },
                'img': {
                    height: '100%',
                    width: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    left: '0',
                    top: '0',
                }
            }),
            control: () => ({
               padding: '0',
               display: 'flex',
               backgroundColor: '#EDEDED',
               alignItems: 'center',
               cursor: 'pointer',
               fontFamily: `'EuropeCondensedc', 'Loos Light', sans-serif`,
               transition: '0.3s cubic-bezier(.7,.33,.25,.87)',
               border: `${!props.validate  ? '1px solid #EB5757' : '1px solid transparent'}`,
               paddingRight: '0.625rem',
               "@media only screen and (max-width: 1200px)": {
                    paddingRight: '0rem'
               }
            }),
            placeholder: (provided, state) => {
                const color = 'black';
                const paddingLeft = '0.625rem';
                return {...provided, color, paddingLeft}
            },
            indicatorsContainer: (styles, { data, isDisabled, isFocused, isSelected }) => ({
                height: '100%',
                position: 'relative',
                width: '3rem',
                transition: '0.3s cubic-bezier(.7,.33,.25,.87)',
                transform: menuIsOpen ?  'rotate(180deg)' : '',
                pointerEvents: 'none',
                'svg': {
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    height: '0.5rem'
                }
            }),
            singleValue: (provided, state) => ({
                ...provided,
                marginLeft: '0',
                marginRight: '0.5rem',
                height: '100%'
            }),
        }
        return(
            <Select 
                ref={selectRef} 
                components={{DropdownIndicator}} 
                options={options} 
                isSearchable={false}
                styles={customStyles} 
                menuIsOpen={menuIsOpen}
                placeholder = {props.placeholder}
                onChange={props.handleChange}
                onClick = {() => menuIsOpen ? setMenuOpen(true) : setMenuOpen(false)}
                onMenuOpen={() => {
                    props.handleChange('');
                    setMenuOpen(true)
                }}
                onMenuClose={(value) => {          
                    setTimeout(() => {
                        if(selectRef.current.props.value !== null) {
                            props.handleChange(selectRef.current.props.value);   
                        }
                        else {
                            props.handleChange({value: ''}); 
                        } 
                    }, 100);
                    setMenuOpen(false)
                }}
                
                
            />)
}